import './App.css';
import { useState, useEffect } from "react";
import Section1 from "./components/mission_principles/index.js";
import ToolsSection from "./components/tools/index.js";
import FaqSection from "./components/faq/index.js";
import CIS from "./components/continuous_improvement_storyboard/index.js";
import Contact from "./components/contact/index.js";

const options = {
  headers: {
    Authorization: "Bearer nplH4KB1TM6t02miIdJF0QqurKn6Hptl",
    'Content-Type': 'application/json'
  }
};

// Fetch helper function with error handling
const fetchData = async (url) => {
  try {
    const resp = await fetch(url, options);
    if (!resp.ok) {
      throw new Error(`HTTP error! Status: ${resp.status}`);
    }
    return await resp.json();
  } catch (error) {
    console.error(`Fetch error for ${url}:`, error);
    return null;
  }
};

const getNavigation = () => fetchData("https://api-als2.nutramax.com/items/navigation_lhl");
const getTools = () => fetchData("https://api-als2.nutramax.com/items/tools_templates_lhl");
const getFAQ = () => fetchData("https://api-als2.nutramax.com/items/faq_lhl");
const getCIS = () => fetchData("https://api-als2.nutramax.com/items/improvement_storyboards");
const getTeam = () => fetchData("https://api-als2.nutramax.com/items/contacts_lhl");
const getWordCloud = () => fetchData("https://api-als2.nutramax.com/items/word_cloud_lhl");

function App() {

  const [links, setLinks] = useState(null);
  const [tools, setTools] = useState(null);
  const [faq, setFaq] = useState(null);
  const [cis, setCis] = useState(null);
  const [teamx, setTeam] = useState(null);
  const [wordCloud, setWordCloud] = useState(null);

  useEffect(() => {
    const fetchStuff = async () => {
      const links = await getNavigation();
      if (links) setLinks(links.data);

      const tools = await getTools();
      if (tools) setTools(tools.data);

      const faqs = await getFAQ();
      if (faqs) setFaq(faqs.data);

      const cis = await getCIS();
      if (cis) setCis(cis.data);

      const team = await getTeam();
      if (team) setTeam(team.data);

      const word = await getWordCloud();
      if (word) setWordCloud(word.data);
    };
    fetchStuff();
  }, []);

  return (
    <div className="main-section">
      <section className="header-section">
        <img src="https://dwsql3bnq6iup.cloudfront.net/lighthouse_learning/Lighthouse+Learning+System+Logo+final.svg" alt="Lighthouse Learning" className="light-logo" />
      </section>

      <section className="link-container">
        {links ? links.map((x, i) => (
          <a
            href={x.name === "Submit a Suggestion" ? "https://forms.office.com/Pages/ResponsePage.aspx?id=2HpMz1BGXkSBpnyCDf5Er_FcbNX8iIJHhJnAiumZKR5UOE0ySEFOOEVJQVpIOEZSWTg2N0o1Q0Y4OC4u" : `#${x.name.replaceAll(" ", "_")}`}
            target={x.name === "Submit a Suggestion" ? "_blank" : "_self"}
            key={i}
            className="nav-link"
            style={{ backgroundColor: x.status !== "published" ? "gray" : null, color: x.status !== "published" ? "white" : null }}
          >
            {x.name} {x.status !== "published" ? <div><span style={{ fontSize: "smaller" }}> COMING SOON </span></div> : null}
          </a>
        )) : null}
      </section>

      {links ? <Section1 links={links} word={wordCloud} /> : null}
      {links && tools ? <ToolsSection links={links} tools={tools} /> : null}
      {links && faq ? <FaqSection links={links} faq={faq} /> : null}
      {links ? <CIS links={links} cis={cis} /> : null}
      {links ? <Contact links={links} contact={teamx} /> : null}
    </div>
  );
}

export default App;
